import React from 'react';
import {
    Stack,
    Card,
    Button,
    ResourceItem,
    Checkbox,
    Thumbnail,
    TextStyle,
    ResourceList,
    Pagination
} from '@shopify/polaris';
import StatItem from './StatItem'
import { GenieTag, ToGenieTag } from '../../components/GenieTag';

function renderPreviewItems(item) {
    const { id, name, image, tagsAfterOperation } = item;

    return (
        <ResourceItem id={id} url={null} media={
            <Thumbnail source={image} alt="image" />
        }>
            <h3 className="previewProductTitle">
                <TextStyle variation="strong">{name}</TextStyle>
            </h3>
            <Stack spacing="tight" distribution="leading" alignment="leading">{ToGenieTag(tagsAfterOperation)}</Stack>
        </ResourceItem>
    );
}

const resourcePageSize = 1;

class ResourcePreviewPaneComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            resourceChangesTooltipActive: false,
            previewOnlyAffected: true,
            previewPage: 0
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.preview === null && prevProps.preview != null) {
            this.setState({
                previewPage: 0
            });
            return;
        }

        if (this.props.preview != null && prevProps.preview == null) {
            this.setState({
                previewPage: 0
            });
        }
    }

    render() {

        const resourceSingular = this.props.resourceSingular;
        const resourcePlural = this.props.resourcePlural;
        // const resourceSingularCapital = this.props.resourceSingular.charAt(0).toUpperCase() + this.props.resourceSingular.slice(1);
        const resourcePluralCapital = this.props.resourcePlural.charAt(0).toUpperCase() + this.props.resourcePlural.slice(1);

        if (this.props.preview != null) {

            let previewItems = this.props.preview.resourcePreviews.map((item, index) => {
                return {
                    id: index,
                    url: null,
                    name: item.title,
                    image: item.image,
                    tagsAfterOperation: item.tagsAfterOperation,
                    isAffected: item.isAffected
                }
            });

            let addedTags = this.props.preview.addedTags.map((item) => <GenieTag selectable={false} state="added">{item}</GenieTag>);
            let removedTags = this.props.preview.removedTags.map((item) => <GenieTag selectable={false} state="removed">{item}</GenieTag>);

            if (this.state.previewOnlyAffected) {
                previewItems = previewItems.filter(item => item.isAffected === true);
            }
            let maxPages = parseInt(previewItems.length / resourcePageSize, 10);
            let sliced = previewItems.slice(resourcePageSize * this.state.previewPage, (resourcePageSize * this.state.previewPage) + resourcePageSize);

            return (
                <React.Fragment>
                    <Card.Section>
                        <Stack vertical={false} distribution="leading" spacing="extraLoose"  >
                            <StatItem
                                title={`Matching ${resourcePluralCapital}`}
                                stat={this.props.preview.totalResources}
                                text={`Total number of  ${resourcePlural} matching the conditions in step 1 (if any).`}
                            />
                            <StatItem
                                title={`Affected ${resourcePluralCapital}`}
                                stat={this.props.preview.affectedResources}
                                text={`Total number of  ${resourcePlural} that will be affected by this operation when executed.`}
                            />
                            <StatItem
                                title="Total Tag changes"
                                stat={this.props.preview.totalTagChanges}
                                text="The number of total tags that will be either removed or added by this operation when executed."
                            />
                        </Stack>
                    </Card.Section>
                    <Card.Section title="Tags to be added/removed">
                        {addedTags.length > 0 && <Stack alignment="center">{[...addedTags]}</Stack>}
                        {removedTags.length > 0 && <Stack alignment="center">{[...removedTags]}</Stack>}
                        {addedTags.length === 0 && removedTags.length === 0 && <span>None</span>}
                    </Card.Section>
                    <Card.Section title="Preview changes">
                        <Checkbox
                            label={`Preview only affected ${resourcePlural}`}
                            checked={this.state.previewOnlyAffected}
                            onChange={() => this.setState({
                                previewOnlyAffected: !this.state.previewOnlyAffected,
                                previewPage: 0
                            })}
                        />
                        <ResourceList
                            resourceName={{ singular: resourceSingular, plural: resourcePlural }}
                            hasMoreItems={true} showHeader={false} totalItemsCount={previewItems.length}
                            items={sliced}
                            renderItem={renderPreviewItems}
                        />
                        <Stack alignment="center" distribution="center"  >
                            <Stack.Item>
                                <Pagination
                                    label={`${this.state.previewPage + 1} of ${previewItems.length} ${resourcePlural}`}
                                    hasPrevious
                                    onPrevious={() => {
                                        this.setState({ previewPage: this.state.previewPage === 0 ? 0 : this.state.previewPage - 1 })
                                    }}
                                    hasNext
                                    onNext={() => {
                                        this.setState({ previewPage: this.state.previewPage === maxPages ? 0 : this.state.previewPage + 1 })
                                    }}
                                />
                            </Stack.Item>
                        </Stack>
                    </Card.Section>
                </React.Fragment >
            );
        }

        return (
            <Button loading={this.props.loadingPreview} onClick={this.props.onPreview} disabled={this.props.disabled}>Preview changes</Button>
        );
    }

    componentDidMount() {
    }
}

ResourcePreviewPaneComponent.defaultProps = {
    preview: {
        resources: [],
        canExecute: false,
        actionCreditsCost: 0,
        affectedTagsCount: 0,
        remainingActionCredits: 0,
        removedTags: [],
        addedTags: [],
        disabled: false
    },
    resourceSingular: "customer",
    resourcePlural: "customers",
}

export default ResourcePreviewPaneComponent;